import { useSidePopout } from 'modules/layout';
import React, { useEffect, useState } from 'react';
import { matchPath, useHistory, useLocation } from 'react-router-dom';
import { StyledSubmenuItem } from './styled';

export interface SubmenuItemProps {
  location: string;
  ariaLabel?: string;
}
export const SubmenuItem: React.FC<SubmenuItemProps> = ({
  location,
  ariaLabel,
  children,
  ...props
}) => {
  const { closePopout } = useSidePopout();
  const history = useHistory();
  const currentLocation = useLocation();
  const [matchesPath, setMatchesPath] = useState<boolean>();

  const handleNavigation = (path: string) => {
    history.push(path);

    closePopout();
  };

  useEffect(() => {
    const isHomepage =
      matchPath(currentLocation.pathname, {
        path: '/',
        exact: true,
      }) !== null;
    if (isHomepage && location === '/') {
      setMatchesPath(true);
    } else if (isHomepage === false && location !== '/') {
      const match = matchPath(currentLocation.pathname, {
        path: location,
        exact: false,
      });
      if (match !== null) {
        setMatchesPath(true);
      } else {
        setMatchesPath(false);
      }
    } else {
      setMatchesPath(false);
    }
  }, [currentLocation.pathname, location]);
  return (
    <StyledSubmenuItem
      aria-label={ariaLabel}
      selected={matchesPath}
      onClick={() => handleNavigation(location)}>
      {children}
    </StyledSubmenuItem>
  );
};
